/* eslint-disable */

const INITIAL_STATE = {
  co2Data: [],
  loadingCo2: false,
  showDateFilter: false,
  unit: 'MWh',
  stacked: true,
  zoom: 1,
  mapCenter: {lat: 0, lng: 0},
  cookiesAccepted: null
};

const utilsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ACCEPT_COOKIES':
      return { ...state,  cookiesAccepted: true }

    case 'DECLINE_COOKIES':
        return { ...state,  cookiesAccepted: false }

    case 'SET_UNIT':
      return { ...state,  unit: action.payload }

    case 'TOGGLE_DATE_FILTER':
      const showDateFilter = !state.showDateFilter;
      return { ...state, showDateFilter }

    case 'HIDE_DATE_FILTER':
      return { ...state, showDateFilter: false }

    case 'DISPLAY_DATE_FILTER':
      return { ...state, showDateFilter: true }

    case 'TOGGLE_STACKED':
      return { ...state,  stacked: !state.stacked }

    case 'SET_MAP_ZOOM_CENTER':
      return { ...state,  zoom: action.payload.zoom, mapCenter: action.payload.center  }

    case 'GET_CO2_START':
      return { ...state, loadingCo2: true }

    case 'GET_CO2_SUCCESS':
      return { ...state, co2Data: action.payload, loadingCo2: false }
    
    case 'GET_CO2_FAIL':
      return { ...state, loadingCo2: false }
    
    default:
      return state
  }
}

export default utilsReducer



// WEBPACK FOOTER //
// ./src/reducers/utilsReducer.js